import * as t from '../actionTypes'
import axios from 'utils/axios'
import { guardFromErrors, extractErrorInfo } from 'utils/graphqlHelpers'

type Payload = {
  productColorId: number
  productColorData: ProductColorInput
}

export type UpdateProductColorAction = FSA<undefined, Payload, string>

type UpdateProductColor = (args: Payload) => MrxThunk<UpdateProductColorAction, Promise<boolean>>

type QueryResponse = GraphQLResponse<'updateProductColor', boolean>

const UPDATE_PRODUCT_COLOR = `
  mutation updateProductColor ($productColorId: Int!, $productColorData: ProductColorDataInput!) {
    updateProductColor(productColorId: $productColorId, productColorData: $productColorData)
  }
`

type ProductColorInput = {
  name: string
  displayName: string
}

const updateProductColor: UpdateProductColor = (args) => async (dispatch) => {
  let isSaved = false

  dispatch({
    type: t.UPDATE_PRODUCT_COLOR,
    meta: { done: false }
  })

  try {
    const { productColorId, productColorData } = args
    const {
      data: { data, errors }
    }: QueryResponse = await axios.post('/graphql', {
      query: UPDATE_PRODUCT_COLOR,
      variables: { productColorId, productColorData }
    })

    guardFromErrors(errors)

    if (!data) {
      throw new Error('Response body is empty!')
    }

    const { updateProductColor } = data
    if (!updateProductColor) {
      throw new Error("Can't update product color!")
    }

    dispatch({
      type: t.UPDATE_PRODUCT_COLOR,
      payload: args,
      meta: { done: true }
    })
    isSaved = true
  } catch (err) {
    dispatch({
      type: t.UPDATE_PRODUCT_COLOR,
      payload: extractErrorInfo(err) as string,
      error: true
    })
  }

  return isSaved
}

export { updateProductColor }
